import script from "./TextDictionary.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextDictionary.vue?vue&type=script&lang=ts&setup=true"

import "./TextDictionary.vue?vue&type=style&index=0&id=e2c46744&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c46744"]])

export default __exports__